import * as React from 'react';
import styled from 'styled-components';
import { Link, Tooltip, theme } from 'components';
import { StyledSkeletonInput } from './commonStyled';

const StyledLink = styled(Link)`
  &&& {
    width: 100%;
    color: ${theme.black};
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &&&:hover {
    text-decoration: underline;
  }
`;

export interface LinkCellProps {
  loading?: boolean;
  type?: 'email';
  value?: string;
  linktext?: string;
  visible?: boolean;
  tooltip?: string;
}

const LINK_PREFIX_MAP = {
  email: 'mailto:',
};

const LinkCell: React.FC<LinkCellProps> = ({
  loading,
  value,
  linktext,
  type,
  tooltip,
  visible = true,
}) => {
  const linkPrefix = LINK_PREFIX_MAP[type] || '';
  const linkValue = linktext !== undefined ? linktext : value;
  if (loading) {
    return <StyledSkeletonInput size="small" />;
  }
  if (tooltip && visible) {
    return (
      <Tooltip title={tooltip} placement="bottom">
        <StyledLink
          onClick={e => e.stopPropagation()}
          href={`${linkPrefix}${linkValue}`}
        >
          {value}
        </StyledLink>
      </Tooltip>
    );
  }
  if (visible) {
    return (
      <StyledLink
        onClick={e => e.stopPropagation()}
        href={`${linkPrefix}${linkValue}`}
      >
        {value}
      </StyledLink>
    );
  }
  return null;
};

export default React.memo(LinkCell);
